import { graphql, useStaticQuery } from 'gatsby'

export const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          supportedLanguages
          siteUrl
          fallbackLanguage
          cdnurlStrapi
          cdnurlStatic
          cdnurlApp
          inDev
        }
      }
    }
  `)

  return data.site.siteMetadata
}
